import { api } from "utils/hostname";
import url from "url/index";

import { useBreakpoint } from "hooks/useBreakpoint";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  GAME_PLATFORM,
  ParamsRequestType,
  GamesResponseType,
} from "types/Games";

import * as gameSelectors from "redux/game/selectors";
import {
  CATEGORIES_ENUMS,
  CATEGORIES_WITH_SPACE,
} from "constants/navigation/categories";
import { gamesApi } from "redux/game/api";
import { useGetParam } from "hooks/useGetParam";
import useQueryParam from "hooks/useQueryParam";
import { GET_PARAMS } from "constants/popupConfig";

export const useGamesRequest = () => {
  const { isDesktop } = useBreakpoint();
  const { take, page, providers, sort } = useSelector(gameSelectors.filter);
  const { category } = useGetParam();
  const providersQuery = useQueryParam(GET_PARAMS.PROVIDERS);
  const searchGames = useSelector(gameSelectors.searchGames);
  const { id: tournamentId } = useParams();
  const withOtherParams =
    !providers?.length && !providersQuery?.length && !tournamentId;

  const params: ParamsRequestType = {
    tournament: tournamentId,
    take,
    page,
    platform: isDesktop ? GAME_PLATFORM.WEB : GAME_PLATFORM.MOB,
    ...(!tournamentId && { sort }),
  };
  if (tournamentId) {
    params.take = isDesktop ? 10 : 9;
  }
  if (providersQuery?.length) {
    params.providers = providersQuery;
  }
  if (providers?.length) {
    params.providers = providers.join(",");
  }
  if (providers?.length === 0) {
    if (providersQuery?.length) {
      params.providers = providersQuery;
    } else {
      params.providers = undefined;
    }
  }
  if (category && category !== CATEGORIES_ENUMS.FAVORITE && withOtherParams) {
    if (CATEGORIES_WITH_SPACE.includes(category as CATEGORIES_ENUMS)) {
      params.categories = category.split("-").join(" ");
    } else {
      params.categories = category;
    }
  }
  if (!category && !searchGames.length && withOtherParams) {
    params.categories = CATEGORIES_ENUMS.POPULAR;
  }
  if (
    category &&
    category === CATEGORIES_ENUMS.POPULAR &&
    !searchGames.length &&
    !providers?.length &&
    !tournamentId
  ) {
    params.top = true;
  }
  if (searchGames?.length) {
    params.name = searchGames;
    params.categories = undefined;
  }
  if (sort && sort.length && withOtherParams) {
    params.sort = sort;
  }

  const [trigger, { isLoading }] = gamesApi.useLazyGamesQuery();

  gamesApi.useProvidersQuery(isDesktop ? GAME_PLATFORM.WEB : GAME_PLATFORM.MOB);
  return {
    fetchGames: (extraParams?: ParamsRequestType) => {
      trigger({ ...params, ...extraParams });
    },
    isLoading,
  };
};

export const fetchBonusGames = async (): Promise<GamesResponseType> => {
  try {
    // const response = await api(true, true, "v1").get<GamesResponseType[]>(
    const response = await api(true, true, "v2").get<GamesResponseType>(
      url.config.api.games.games,
      {
        params: {
          take: 30000,
        },
      },
    );
    return response.data;
  } catch (error) {
    throw new Error("Failed to fetch banners");
  }
};
